import type { GetPublicSettings } from '@virtual-care/client';
import { useData } from '@virtual-care/ui';

export function useSettings() {
  const settings = useData(
    'GET /settings/public',
    {},
    {
      staleTime: Infinity,
    },
  );
  return settings.data;
}

export function useSetting(name: keyof GetPublicSettings) {
  const settings = useSettings();
  return settings ? settings[name] : undefined;
}

export function useSettingValue(name: keyof GetPublicSettings) {
  return useSetting(name)?.value;
}

const FALLBACK_SUPPORT_PHONE = '+966112027444';

/**
 * Support phone shared by the footer contact link and the floating WhatsApp
 * button. Reads the `supportPhoneNumber` public setting and falls back to the
 * head-office number when the setting is unset.
 */
export function useSupportPhone() {
  return useSettingValue('supportPhoneNumber') ?? FALLBACK_SUPPORT_PHONE;
}
